import { CADASTRO_ACTION } from '../Pesquisa/pesquisarRamoAtividade.constants';

export const routeName = acao => [acao === CADASTRO_ACTION ? 'Novo Cadastro de Ramos de Atividade' : 'Editar Cadastro de Ramo de Atividade'];
export const FIELD_LABEL = 'Ramo de Atividade*';
export const SUBTITLE_FORM = 'Informe o Ramo de Atividade';
